module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_16.fe19c4c8.jpg";